import styled from "styled-components";

import "../../../../../GlobalStyles/Font.css";

export const SignInHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SignInTitle = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;

  @media (min-width: 428px) {
  }
`;

export const SignInModelContainer = styled.div`
  background: #fff;
  max-width: 326px;
  border-radius: 20px;
  padding: 16px 20px;
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 449px;
  }
`;

export const SignInListItem = styled.li`
  margin-top: 20px;

  &:first-child {
    margin-top: 24px;
  }
`;

export const SignInForgotPasswordContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 20px;
`;

export const SignInButtonForgotPassword = styled.button`
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;
  color: #000;
  cursor: pointer;
`;
